import { FormattedMessage, useIntl } from 'react-intl';
import { FilterState, useResetFilters } from '@Component/Filter/utils.ts';
import { SearchIllustration } from '@tlx/atlas';
import { TableEmptyState } from '@Component/Table/Table.utils.tsx';

export function TableEmptyResetFilter(filters: FilterState) {
    const resetFilter = useResetFilters(filters);
    return (
        <TableEmptyState
            illustration={<SearchIllustration size={'small'} />}
            onClickAction={resetFilter}
            titleMessage={<FormattedMessage id="tsk_filter_results_empty" />}
            descriptionMessage={<FormattedMessage id="tsk_filter_results_empty_description" />}
            buttonContent={<FormattedMessage id="text_reset_filter" />}
        />
    );
}

export function NewTableEmptyResetFilter(filters: FilterState) {
    const intl = useIntl();
    const resetFilter = useResetFilters(filters);

    return (
        <TableEmptyState
            titleMessage={intl.formatMessage({
                id: 'text_no_results',
            })}
            descriptionMessage={intl.formatMessage({
                id: 'tsk_filter_results_empty_description',
            })}
            buttonContent={intl.formatMessage({
                id: 'text_reset_filter',
            })}
            illustration={<SearchIllustration size={'small'} />}
            onClickAction={resetFilter}
        />
    );
}
